import $ from 'jquery';
import pubSub from './pubSub';

import initArticleListOrder from './article-list-order';
import initPagination from './pagination';
import spinnerUtils from './spinner';
import manageSearchResultCategories from './searchresult-categories';
import initRangeSliders from './range';

/**
 * @param  {Node} scope The scope in which to search for filter dropdowns
 * @return {void}
 */
export function filterDropdown(scope = document) {
  $(scope).find('.js-dropdown').on('click', (event) => {
    const element = $(event.currentTarget);
    element.toggleClass('active', 500);
    element.siblings('.category-filter__dropdown, .category-content-navigation, .productdetailstext').toggleClass('active', 500);

    // check for data attribute text and replace if text is available
    if (element.data('text') !== undefined) {
      const currentText = element.text();
      const newText = element.data('text');

      element.text(newText);
      element.data('text', currentText);
    }
  });

  $(scope).find('.js-dropdown-item__label').on('click', (event) => {
    $('.js-dropdown-item__label').not(event.currentTarget).siblings('.dropdown-item__option.active').removeClass('active');
    $('.js-dropdown-item__label.active').not(event.currentTarget).removeClass('active');
    $(event.currentTarget).toggleClass('active', 500);
    $(event.currentTarget).siblings('.dropdown-item__option').toggleClass('active', 500);
  });
}

/**
 * @param  {Node} scope The scope in which to search for filter tags
 * @return {void}
 */
export function initFilterTags(scope) {
  if (scope === null) return false;

  $(scope).find('.tag').on('click', (event) => {
    const element = $(event.currentTarget);
    const form = $('form[name=filterlist]');
    const filterItemId = element.data('filteritemid');
    const filterItem = form.find(`#${filterItemId}`);

    const filterType = filterItem.parents('.dropdown-item').data('filtertype');

    switch (filterType) {
      case 'checkbox': {
        // uncheck the respective filter param and resend the form
        filterItem.attr('checked', false);
        form.submit();
        break;
      }
      case 'price':
        // falls through
      case 'range': {
        // set the slider range to min and max and resend the form
        const rangeGroup = form.find(`#${filterItemId}`);
        const inputMin = $('input.js-amount_min', rangeGroup);
        const inputMax = $('input.js-amount_max', rangeGroup);
        const inputActiveFlag = rangeGroup.siblings('input.js-amount_active');
        inputMin.val(inputMin.attr('min'));
        inputMax.val(inputMax.attr('max'));
        inputActiveFlag.val(0);
        form.submit();
        break;
      }
      default:
        break;
    }

    return false;
  });

  return true;
}

/**
 * @param  {Event} event The trigger
 * @param  {String} filterURL The url to call to get the new content
 * @return {void}
 */
function reloadContentWithFilterURL(event, filterURL) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    const token = spinnerUtils.create();

    // AJAX
    xhr.open('GET', filterURL);
    xhr.send();
    xhr.onload = () => {
      if (xhr.status === 200) {
        const container = event.target.closest('.load-more-content');

        // set content
        container.innerHTML = xhr.responseText;

        // reinit scripts
        initFilterTags(document.querySelector('.delete-option'));
        initPagination(container);
        initArticleListOrder(container);
        $('.accordion').Accordion();
        filterDropdown(container);
        manageSearchResultCategories();
        initRangeSliders(container);
        registerFilterResetEventlistener(container); // eslint-disable-line no-use-before-define

        // publish message
        pubSub.publish('reloaded.content', {
          scope: container[0],
        });
      }

      // destroy spinner
      spinnerUtils.destroy(token);
    };

    resolve();
  });
}

/**
 * @param  {Node} scope The scope in which to search for the filter form
 * @return {void}
 */
export function registerFilterResetEventlistener(scope = document) {
  const backToAllProductsButtons = [].slice.call(scope.querySelectorAll('[data-reset-filter-page-url]'));
  const resetFilterButtons = [].slice.call(scope.querySelectorAll('[data-reset-filter-partial-url]'));

  // back to all products
  if (backToAllProductsButtons.length > 0) {
    backToAllProductsButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        reloadContentWithFilterURL(event, button.dataset.resetFilterPageUrl);
      });
    });
  }

  // remove all filters
  if (resetFilterButtons.length > 0) {
    resetFilterButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        reloadContentWithFilterURL(event, button.dataset.resetFilterPartialUrl);
      });
    });
  }
}

/**
 * @param  {Node} scope The scope in which to search for the filter form
 * @return {void}
 */
export function initFilterForm(scope = document) {
  // bind delegated event to filterform that will be loaded asynchronously in tab content
  $(scope).find('.tabs').on('submit', 'form[name=filterlist]', (event) => {
    const form = $(event.currentTarget);
    // send the form via ajax?
    if (form.data('method') === 'ajax') {
      event.preventDefault();

      const url = form.attr('action');
      const params = form.serializeArray();
      const token = spinnerUtils.create();

      // we only load the products partial (searchtype=2)
      params.push({ name: 'searchtype', value: '2' });
      $.get(url, params, (data) => {
        if (data.length > 0) {
          const container = $(form).closest('.load-more-content');

          container.html(data);

          initFilterTags(document.querySelector('.delete-option'));
          initPagination(container);
          initArticleListOrder(container);
          registerFilterResetEventlistener();

          pubSub.publish('reloaded.content', {
            scope: container[0],
          });
        }

        // destroy spinner
        spinnerUtils.destroy(token);
      });
    }
  });

  // bind delegated event to category filter items
  $(scope).find('.tabs').on('click', '.js-categoryfilter', (event) => {
    const element = $(event.currentTarget);

    if (element.data('store') === 'category') {
      const categoryId = element.data('value');
      const form = element.closest('.load-more-content').find('form[name=filterlist]');
      const categoryFilterInput = form.find('input[name=filtercategory]');

      categoryFilterInput.val(categoryId);
      form.submit();
      window.scrollTo(0, 0);
    }
  });

  registerFilterResetEventlistener(scope);
}



// WEBPACK FOOTER //
// ./assets/js/components/filter.js